"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.anyProp = void 0;

var util_1 = require("../util");
/**
 * Allows any type. No built-in runtime validation is performed by default.
 *
 * Type parameter `T` can be used to restrict the type at compile time.
 *
 * @param validator - Optional function for runtime validation; should return `undefined` if valid, or an error string if invalid.
 */


var anyProp = function anyProp(validator) {
  return (0, util_1.propOptionsGenerator)(undefined, validator);
};

exports.anyProp = anyProp;